import * as Factory from 'factory.ts'
import faker from 'faker'

import { type ShippingTermApiModel } from '../ShippingTermApiModel'

export const ShippingTermApiModelStub =
  Factory.Sync.makeFactory<ShippingTermApiModel>({
    id: Factory.each(() => faker.random.number()),
    name: Factory.each(() => faker.random.words()),
    active: true,
    description: Factory.each(() => faker.random.words()),
  })
